export default "__VITE_ASSET__ghh$KQtX__"